<template>
  <div class="wrap-content branding-page">
    <div class="filter-section">
      <div class="row">
        <div class="col-md-4">
          <h2>Labelling Configurations</h2>
        </div>
      </div>
    </div>

    <div class="config-card-switch">
      <div class="row">
        <div class="col-md-12">
          <div class="card custom-card">
            <div class="row">
              <div class="col-sm-7">
                <div class="fields-area">
              <div class="brand-logo-area">
                <h5>Brand Logo</h5>
                <div class="row">
                  <div class="col-md-9">
                    <base-upload-file
                        type="logo"
                        :accept-file="acceptFile"
                        :label-val="'LOGO'"
                        :placeholder-val="placeholder"
                        @set-value="
                                                getLogoValue($event)
                                            "
                    ></base-upload-file>
                  </div>
                  <div class="col-md-3">
                    <div class="brand-logo light">
                      <div
                          v-if="formData.logo"
                          class="logo-area-preview"
                          :style="{
                                                    'background-image':
                                                        'url(' +
                                                        imageFilePath +
                                                        ')',
                                                }"
                      ></div>
                    </div>
                  </div>
                  <em class="dropzoneText" style="padding-left: 10px;">
                    <strong>Note:</strong> Please ensure that your logo is in PNG format and has dimensions of 250x100 pixels before uploading. If the dimensions are incorrect, your logo may appear stretched, squished, or otherwise disproportionate when displayed.
 <br>If you need any assistance with adjusting the logo to meet these specifications, feel free to reach out to your sales representative for support.

                  </em>

                </div>
              </div>
            </div>
              </div>
              <div class="col-sm-5">
                <label>YOUR LOGO WILL BE DISPLAYED IN THE FOLLOWING AREAS:</label>
          <ul class="">
            <li><strong>Deep-link Journey Screens:</strong> Your customers will see your logo as they navigate through their journey on deep-link screens.</li>
            <li><strong>Deep-link Emails:</strong> When customers receive an email from Idenfo Support, the email content will display your logo and reference your company name.</li>
            <li><strong>Customer Profile PDF Exports:</strong> Documents that export customer data will showcase your logo.</li>
          </ul>
          <em class="">Please Note: The web platform you will be using internally will continue to be Idenfo Direct.</em>
        </div>
            </div>
            

            <div class="row">
              <div class="col-md-12">
                <b-button v-if="formData.logo.fileName"
                    type="submit"
                    variant="primary"
                    :class="loading ? 'disabled' : ''"
                    @click.prevent="updateBrandingData()"
                >
                  <span class="btn-text">UPDATE</span>
                  <span class="loader"></span>
                </b-button>
                <b-button v-if="formData.logo.fileName"
                    type="submit"
                    variant="secondary"
                    :class="loading ? 'disabled' : ''"
                    @click.prevent="resetBranding()"
                >
                  <span class="btn-text">Reset</span>
                  <span class="loader"></span>
                </b-button>
              </div>
            </div>
          </div>
        </div>
       
      </div>
    </div>
    <!-- {{ this.formData.logo.dark.fileName }} -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'
const viewBrandingResource = new resource('configurations/labeling')
// const viewFilesResource = new resource('files')
const fileUrl = process.env.VUE_APP_API_URL

export default {
  components: {},

  /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
  props: {}, // End of Component > props
  /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
  computed: {
    ...mapGetters([
      'dataSegmentId',
      'loading',
      'data',
      'logoLight',
      'displaySettings',
    ]),
  }, // End of Component > computed

  /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
  data() {
    return {
      imageFilePath: process.env.VUE_APP_API_URL,
      light: false,
      query: {
        dataSegmentId: null,
      },
      placeholder:"Choose file to upload",
      formData: {
        logo: {
          fileName: '',
          originalName: ''
        },
        dataSegmentId:null,
        },
      acceptFile: 'image/png',

    }
  }, // End of Component > methods

  /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */
  mounted() {
    this.getBrandingData()
  }, // End of Component > data

  /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
  methods: {
    getLogoValue(fileObj) {
      this.formData.logo.fileName = fileObj.fileName
      this.formData.logo.originalName = fileObj.originalName
      this.imageFilePath = fileUrl + 'files/logo/' + fileObj.fileName
      // this.placeholder = fileObj.originalName
    },

    async getBrandingData() {
      this.query.dataSegmentId = this.dataSegmentId
      let { data } = await viewBrandingResource.list(this.query)
      this.formData = data.data
      this.imageFilePath =
          fileUrl + 'files/logo/' + data.data.logo.fileName
          this.placeholder = data.data.logo.originalName ? data.data.logo.originalName : "Choose file to upload"

    }, // End of getBrandingData() method

    async updateBrandingData() {
      try {
        // Update Config Branding in auth store
        this.formData.dataSegmentId = this.dataSegmentId
        await this.$store.dispatch(
            'updateConfigLabeling',
            this.formData
        )
        // this.$store.commit('setDisplaySetting', this.formData)

        await this.getBrandingData()
      } catch (error) {
        console.log(error, 'There is an error update Branding')
      }
    }, // End of updateConfigBranding() method
    async resetBranding() {
      try {
        // Update Config Branding in auth store
        this.formData.logo= {
          fileName: '',
          originalName: ''
        }
        this.formData.dataSegmentId = this.dataSegmentId
        await this.$store.dispatch(
            'updateConfigLabeling',
            this.formData
        )
        // this.$store.commit('setDisplaySetting', this.formData)
        this.placeholder="Choose file to upload"

        await this.getBrandingData()
      } catch (error) {
        console.log(error, 'There is an error update Branding')
      }
    }

  }, // End of Component > mounted
} // End of export default
</script>
